import { AggregationTypes } from 'reporting-snowflake/relational/schema/column-records';
import { getFilteredAggregationOptions, isMagicMeasure, setColumnAggregation, createDefaultMeasure } from 'reporting-snowflake/relational/utils/column-utils';
import { getCurrentColumn, getPropertyFromMeta } from './property-utils';
export const getColumnValue = column => {
  const table = column.field.table || '';
  const name = column.field.name;
  return table ? `${table}.${name}` : `.${name}`;
};
export const getIsStagedColumn = (propertyValue, stagedColumns) => {
  return stagedColumns.some(stagedColumn => getColumnValue(stagedColumn) === propertyValue);
};
export const columnIsDuplicate = (column1, column2) => {
  if (getColumnValue(column1) !== getColumnValue(column2)) {
    return false;
  }
  return true;
};
export function createColumnWithValidAggregation({
  allAvailableColumns,
  value,
  metricAlias,
  relationalReport,
  tableAndPropertyMeta
}) {
  const foundColumn = allAvailableColumns.find(column => {
    const field = column.field;
    return `${field.table}.${field.name}` === value;
  });
  if (!foundColumn.aggregation) {
    const field = foundColumn.field;
    const property = getPropertyFromMeta(value, tableAndPropertyMeta);
    if (property) {
      let newColumn = createDefaultMeasure(field, property);
      newColumn = newColumn.set('alias', metricAlias);
      return newColumn;
    }
  }
  const currentColumn = getCurrentColumn(relationalReport, metricAlias);
  const currentAggregation = currentColumn === null || currentColumn === void 0 ? void 0 : currentColumn.get('aggregation');
  const validAggregationOptions = getFilteredAggregationOptions(foundColumn);
  const isCurrentAggregationValid = validAggregationOptions.some(option => option.value === currentAggregation);
  const disabled = isMagicMeasure(foundColumn) || foundColumn.aggregation === AggregationTypes.DELEGATE;
  let newColumn = foundColumn.set('alias', metricAlias);
  if (!disabled && isCurrentAggregationValid) {
    newColumn = newColumn.delete('transform').delete('limit').delete('sort');
    newColumn = setColumnAggregation(newColumn, currentAggregation);
  }
  return newColumn;
}